import { selectPlaces, selectMapStatus, updateMapOption } from './mapSlice'
import MarkerClusterGroup from 'react-leaflet-markercluster'
import { useHistory, useParams } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { renderToStaticMarkup } from 'react-dom/server'
import { Marker } from 'react-leaflet'
import Loading from 'components/Loading'
import { STATUS } from 'utils/constants'
import Sygnet from './Sygnet'
import L from 'leaflet'

const Markers = ({ mapRef, lightTheme }) => {
  const status = useSelector(selectMapStatus)
  const places = useSelector(selectPlaces)
  const { placeId } = useParams()

  const dispatch = useDispatch()
  const { push, replace } = useHistory()

  const action = path => /^\/map\/.+$/.test(window.location.pathname) ? replace(path) : push(path)

  return (
    <>
      {status === STATUS.pending && <Loading middleOfPage />}
      {status === STATUS.succeed && <MarkerClusterGroup>
        {places.map(({ id, gpslatitude, gpslongitude, distance, marker_text, marker_color }) => {
          const mapPosition = [gpslatitude || 51.666, gpslongitude || 19.389]
          const isSelected = placeId === id

          return <Marker
            key={id}
            position={mapPosition}
            icon={buildIcon({ marker_text, marker_color, distance, isSelected, lightTheme })}
            zIndexOffset={isSelected ? 1000 : 0}
            eventHandlers={{
              click() {
                const zoom = mapRef.current._zoom || 8
                if (window.document.scrollingElement.scrollTop > 0) {
                  window.scrollTo(0, 0)
                }

                dispatch(updateMapOption({ mapPosition, zoom }))
                action(`/map/${id}`)
              }
            }}>
          </Marker>
        })}
      </MarkerClusterGroup>}
    </>
  )
}

const buildIcon = ({ marker_text, marker_color, distance, isSelected, lightTheme }) => {
  const html = renderToStaticMarkup(
    <div className={`mapMarker ${isSelected ? '--selected' : lightTheme ? '--light' : '--dark'}`}>
      <div className='mapMarker__inner'>
        <div className='mapMarker__top'>{marker_text}</div>
        <div className='mapMarker__center'>
          <Sygnet color={marker_color} />
        </div>
        {distance && <div className='mapMarker__bottom'>{distance} km</div>}
      </div>
      <div className='mapMarker__arrow' />
    </div>
  )

  return L.divIcon({
    html,
    className: 'custom-marker',
    iconSize: null,
    iconAnchor: [60, 120],
  })
}

export default Markers